import React, {useEffect, useState} from "react";
import {useIntl} from "react-intl";
import axios from "axios";
import './EventSheetTemplateForm.scss'
import errorParser from "../../../../components/ErrorParser/ErrorParser";
import {toast} from "react-toastify";
import {useNavigate, useOutletContext, useParams} from "react-router-dom";
import LoadingComp from "../../../../components/elements/LoadingComp/LoadingComp";
import Button from "../../../../components/elements/Button/Button";
import Selector from "../../../../components/elements/Selector/Selector";
import EventSheetAddSection from "./EventSheetAddSection";
import {requiredFields} from "../../../../utils/constants";
import SectionsList from "./SectionsList";
import {eventSheet} from "../../../../utils/sheets";

export default function EventSheetTemplateForm() {

    const intl = useIntl();
    const navigate = useNavigate()
    let params = useParams();
    const id = parseInt(params.id)
    const jwt = localStorage.getItem('jwt')

    const [eventTypes, setEventTypes] = useState([]);
    const [eventType, setEventType] = useState("");
    const [sections, setSections] = useState([]);
    const [sectionOptions, setSectionOptions] = useState([]);
    const [showAddSectionModal, setShowAddSectionModal] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false)
    const [loading, setLoading] = useState(true)
    const {context} = useOutletContext()

    useEffect(() => {

        getEventTypes()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getEventTypes = async () => {
        axios.get(process.env.REACT_APP_API + '/event-types', {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                let temp = []
                for (let i = 0; i < response.data.length; i++) {
                    temp.push({
                        value: response.data[i].title,
                        label: intl.formatMessage({id: 'general.event_type.' + response.data[i].title})
                    })
                }
                setEventTypes(temp)
                if (id && id > 0)
                    getData()
                else
                    setLoading(false)
            })
            .catch(err => {
                errorParser(err, intl)
            })
    }
    const getData = async () => {
        axios.get(process.env.REACT_APP_API + '/event-sheet-templates/' + params.id, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                if (response.data) {
                    await setEventType(response.data.event_type)
                    await setSections(response.data.sections)
                    await handleEventTypeChange(response.data.event_type, false)

                    setLoading(false)
                }
            })
            .catch(err => {
                errorParser(err, intl)
            })
    }

    const save = async (e) => {
        e.preventDefault();

        const emptySections = Object.keys(sections).filter(sectionKey => {
            return !sections[sectionKey] || Object.keys(sections[sectionKey]).filter(item => item !== 'order').length === 0;
        });

        if (emptySections.length > 0) {
            // poți afișa numele secțiunilor goale
            const emptySectionsLabels = emptySections
                .map(sec => intl.formatMessage({id: 'events.sheet.' + sec}));

            toast.error(
                intl.formatMessage({id: 'errors.section_empty'}) + ": " + emptySectionsLabels.join(", ")
            );
            return; // nu salvăm
        }


        setSaveLoading(true)

        await axios.post(process.env.REACT_APP_API + '/event-sheet-templates/' + params.id, {
            event_type: eventType,
            sections: sections,
            standard_fields: [] // câmpuri standard fixe
        }, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                toast.success(intl.formatMessage({id: 'errors.success.data_has_been_saved'}))
                context.setContentUpdated(false)
                navigate(-1)
            })
            .catch(err => {
                errorParser(err, intl)
            })


        setSaveLoading(false)
    }
    const handleEventTypeChange = (value, updateSections = true) => {
        setEventType(value);

        const standardSections = eventSheet[value];

        if (updateSections) {
            context.setContentUpdated(true);
            setSections([])
            const requiredForEvent = requiredFields[value] || {};
            let sectionsTemp = {}
            let sectionOrder = 1;
            Object.keys(requiredForEvent).forEach(sectionKey => {
                if (!sectionsTemp[sectionKey]) {
                    sectionsTemp[sectionKey] = { order: sectionOrder++ } ; // dacă secțiunea nu există în standard, o creăm goală
                }
                let fieldOrder = 1;
                requiredForEvent[sectionKey].forEach(fieldName => {
                    if (standardSections[sectionKey] && standardSections[sectionKey][fieldName]) {
                        sectionsTemp[sectionKey][fieldName] = {
                            ...standardSections[sectionKey][fieldName],
                            required_field_in_sheet_template: true,
                            order: fieldOrder++
                        };
                    }
                });
            });
            setSections(sectionsTemp)
        }

        if (standardSections) {
            let temp = []
            Object.keys(standardSections).forEach(sectionKey => {
                const section = standardSections[sectionKey];
                // filtrăm câmpurile obligatorii
                const fields = Object.keys(section)
                    .map(fieldKey => ({
                        ...section[fieldKey],
                        key: fieldKey,
                        value: fieldKey,
                        label: intl.formatMessage({id: 'events.sheet.' + sectionKey + '.' + fieldKey}),
                    }));

                temp.push({
                    value: sectionKey,
                    label: intl.formatMessage({id: 'events.sheet.' + sectionKey}),
                    fields: fields
                })
            })

            setSectionOptions(temp);
        } else {
            setSectionOptions([]);
        }
    };
    const handleAddSection = (sectionKey) => {
        const sectionsTemp = {...sections}
        const nextOrder = Object.keys(sectionsTemp).length + 1;
        sectionsTemp[sectionKey] = {order: nextOrder}
        setSections(sectionsTemp);
        setShowAddSectionModal(false);
        context.setContentUpdated(true);
    };
    if (loading) {
        return <LoadingComp/>
    }

    return (
        <div className="container event-sheet-template" key={sections.length + eventType}>
            <div className={"row"}>
                <div className={"col-12"}>
                    <h1 className={"container-title"}>{intl.formatMessage({id: 'general.sidebar.event_sheet_templates'})}</h1>
                </div>
                <div className={"col-12"}>
                    <div className="card">

                        <div className={"header"}>
                            <p>{intl.formatMessage({id: 'settings.event_sheet_templates.' + (id ? 'edit' : 'create') + '_template'})}</p>
                        </div>

                        <form onSubmit={(e) => save(e)}>
                            <div className={"content"}>
                                <div className={"row"}>
                                    <div className={"col-12"}>

                                        <div className={"form-control"}>
                                            <div
                                                className={"form-label"}>{intl.formatMessage({id: 'menus.event_type'})}<span
                                                className={"form-required"}>*</span></div>
                                            <Selector
                                                disabled={!!id}
                                                options={eventTypes}
                                                value={eventType}
                                                key={eventType}
                                                onChange={(option) => handleEventTypeChange(option.value)}
                                            />
                                        </div>

                                    </div>
                                    <div className={"col-12"}>
                                        <SectionsList sections={sections} setSections={setSections}
                                                      context={context}
                                                      sectionOptions={sectionOptions}/>
                                    </div>
                                    {eventType && <div className={"col-12"}>
                                        <Button
                                            icon={"fa-solid fa-plus"}
                                            className={"btn-primary mt-3 w-100"}
                                            value={intl.formatMessage({id: 'settings.event_sheet_templates.add_section'})}
                                            onClick={() => setShowAddSectionModal(true)}
                                        />
                                    </div>}
                                    {/* Modal */}
                                    <EventSheetAddSection
                                        modalIsOpen={showAddSectionModal}
                                        setModalIsOpen={setShowAddSectionModal}
                                        onAdd={handleAddSection}
                                        sections={sections}
                                        sectionOptions={sectionOptions}
                                    />
                                </div>
                            </div>
                            <div className={"footer"}>
                                <div className={"row"}>
                                    <div className={"col-12 col-md-6"}>
                                        <Button
                                            className={"btn-light mt-2"}
                                            icon={"fa-solid fa-chevron-left"}
                                            value={intl.formatMessage({id: 'general.buttons.back'})}
                                            onClick={() => {
                                                context.setLeavePage(true)
                                                context.setNextLink('/event-sheet-templates')
                                            }}
                                        />
                                    </div>
                                    <div className={"col-12 col-md-6 d-flex"}>
                                        <Button
                                            className={"btn-secondary mt-2 ms-auto"}
                                            icon={"fa-regular fa-floppy-disk"}
                                            value={intl.formatMessage({id: 'general.buttons.save'})}
                                            disabled={saveLoading}
                                            loading={saveLoading}
                                            type={'submit'}
                                        />
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
        ;
}
